export const PublicationStatus = {
  QA_STAGING: 'QaStaging',
  PUBLISHED: 'Published',
} as const;

export const PublishStatus = {
  ACTIVE: 'Active',
  HIDDEN: 'Hidden',
  DISABLED: 'Disabled',
} as const; 